import Backbone from 'backbone';
import group from './group';

export default Backbone.Collection.extend({
  model: group,

  deactivateAll(id) {
    this.forEach(model => {
      if (!(model.get('id') == id)) {
        model.set('is_selected', false);
      }
    });
  }
});
